const historyApi = window.PartnerSelectionHistory;
const FORM_SELECTOR = "[data-partner-selection-form]";
const DEFAULT_ERROR_MESSAGE = "Une erreur est survenue pendant l'envoi. Reessayez dans quelques instants.";
const DEFAULT_SUBMIT_LABEL = "Envoyer ma sélection";

async function clearCart() {
  await fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

function toggleMessage(form, type, visible) {
  const el = form.querySelector(`[data-partner-selection-${type}]`);
  if (!el) return;
  el.classList.toggle("hidden", !visible);
}

function setErrorMessage(form, message) {
  const el = form.querySelector("[data-partner-selection-error]");
  if (!el) return;
  el.textContent = message || DEFAULT_ERROR_MESSAGE;
}

function toggleActions(form, visible) {
  const el = form.querySelector("[data-partner-selection-actions]");
  if (!el) return;
  el.classList.toggle("hidden", !visible);
}

async function submitSelection(form, submitButton) {
  if (!form || !submitButton) return;
  if (form.dataset.submitting === "true") return;
  form.dataset.submitting = "true";

  const loadingMessage = form.querySelector("[data-partner-selection-loading]");
  const proxyPath = form.dataset.proxyPath;
  const shouldClearCart = form.dataset.clearCart === "true";
  const payloadScript = form.querySelector("[data-partner-selection-payload]");

  if (!proxyPath || !payloadScript) {
    setErrorMessage(form, DEFAULT_ERROR_MESSAGE);
    toggleMessage(form, "error", true);
    form.dataset.submitting = "false";
    return;
  }

  let payload;
  try {
    payload = JSON.parse(payloadScript.textContent || "{}");
  } catch {
    setErrorMessage(form, DEFAULT_ERROR_MESSAGE);
    toggleMessage(form, "error", true);
    form.dataset.submitting = "false";
    return;
  }

  toggleMessage(form, "error", false);
  toggleMessage(form, "success", false);
  toggleActions(form, false);
  setErrorMessage(form, DEFAULT_ERROR_MESSAGE);

  if (loadingMessage) {
    loadingMessage.classList.remove("hidden");
  }
  submitButton.disabled = true;
  submitButton.setAttribute("aria-busy", "true");
  submitButton.textContent = "Envoi en cours...";

  try {
    const response = await fetch(proxyPath, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      let errorMessage = `Erreur proxy (${response.status})`;
      try {
        const data = await response.json();
        if (data?.error) errorMessage = data.error;
      } catch {
        // keep fallback message
      }
      throw new Error(errorMessage);
    }

    if (historyApi?.saveFinal) {
      historyApi.saveFinal(payload);
    }

    toggleMessage(form, "success", true);
    toggleActions(form, true);
    submitButton.classList.add("hidden");
    submitButton.disabled = true;
    submitButton.removeAttribute("aria-busy");
    submitButton.textContent = DEFAULT_SUBMIT_LABEL;
    form.dataset.submitted = "true";
    form.dataset.clearCartAfterSubmit = shouldClearCart ? "true" : "false";
  } catch (error) {
    setErrorMessage(form, error instanceof Error ? error.message : DEFAULT_ERROR_MESSAGE);
    toggleMessage(form, "error", true);
  } finally {
    if (loadingMessage) {
      loadingMessage.classList.add("hidden");
    }
    if (form.dataset.submitted !== "true") {
      submitButton.disabled = false;
      submitButton.removeAttribute("aria-busy");
      submitButton.textContent = DEFAULT_SUBMIT_LABEL;
    }
    form.dataset.submitting = "false";
  }
}

async function handleSuccessActionClick(event, element) {
  const form = element.closest(FORM_SELECTOR);
  if (!(form instanceof HTMLElement)) return;

  const shouldClearCart = form.dataset.clearCartAfterSubmit === "true";

  if (element.matches("[data-partner-selection-continue]")) {
    event.preventDefault();
    if (shouldClearCart) {
      await clearCart();
      window.location.href = `${window.location.origin}${window.location.pathname}`;
      return;
    }
    const dialog = form.closest("dialog");
    if (dialog && typeof dialog.close === "function") dialog.close();
    return;
  }

  if (element.matches("[data-partner-selection-view]")) {
    if (shouldClearCart) {
      event.preventDefault();
      const historyUrl = form.dataset.selectionHistoryUrl || element.getAttribute("href") || "/pages/mes-selections";
      await clearCart();
      window.location.href = historyUrl;
    }
  }
}

document.addEventListener("click", (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const submitButton = target.closest("[data-partner-selection-submit]");
  if (submitButton instanceof HTMLButtonElement) {
    const form = submitButton.closest(FORM_SELECTOR);
    if (!(form instanceof HTMLElement)) return;

    event.preventDefault();
    submitSelection(form, submitButton);
    return;
  }

  const successAction = target.closest("[data-partner-selection-continue], [data-partner-selection-view]");
  if (!(successAction instanceof Element)) return;
  handleSuccessActionClick(event, successAction);
});
